

















































































































import Vue from 'vue';
import { mapState } from 'vuex';
import Api from '@/mixins/api';
import Helpers from '../mixins/helpers';
import Validation from '../mixins/validation';
import FieldText from '@/components/dumb/FieldText.vue';
import FieldRadioButton from '@/components/dumb/FieldRadioButton.vue';
import FieldPhone from '@/components/dumb/FieldPhone.vue';
import FieldAddress from '@/components/dumb/FieldAddress.vue';
import OldBirthdayField from '@/components/dumb/OldBirthdayField.vue';
import Analytics from '@/mixins/analytics';

export default Vue.extend({
	name: 'DetailForm', 
	props: {
		value: Boolean, 
		disabled: Boolean
	}, 
	components: {
		FieldText, 
		FieldRadioButton, 
		FieldPhone, 
		FieldAddress, 
		OldBirthdayField
	},
	data(): any {
		return {
			personalBusinessTab: 0, 
			isFormValid: null, 
			titleOptions: [
				'Mr',
				'Mrs', 
				'Ms', 
				'Miss'
			], 
			dealershipOptions: []
		};
	}, 
	computed: {
		...mapState({
			app(): any { return this.$store.state.app },
			dealer(): any { return this.$store.state.dealer },
			vehicle(): any { return this.$store.state.vehicle },
			customer(): any { return this.$store.state.customer },
			tpr(): any { return this.$store.state.tpr }
		}), 
		emailRules(): Array<Function> {
			return [Validation.isEmail];
		}, 
		customerTitle: {
			get(): string {
				return this.customer.title;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					title: v
				});
			}
		},
		customerCompanyName: {
			get(): string {
				return this.customer.companyName;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					companyName: v
				});
			}
		}, 
		customerAbn: {
			get(): string {
				return this.customer.abn;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					abn: v
				});
			}
		}, 
		customerFirstName: {
			get(): string {
				return this.customer.firstName;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					firstName: v
				});
			}
		}, 
		customerPreferredName: {
			get(): string {
				return this.customer.preferredName;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					preferredName: v
				});
			}
		}, 
		customerLastName: {
			get(): string {
				return this.customer.lastName;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					lastName: v
				});
			}
		}, 
		customerEmail: {
			get(): string {
				return this.customer.email;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					email: v
				});
			}
		}, 
		customerPhone: {
			get(): string {
				return this.customer.phone;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					phone: v
				});
			}
		}, 
		customerAddress: {
			get(): object {
				return {
					postcode: this.customer.postcode,
					address: this.customer.address,
					unitNo: this.customer.unitNo,
					sa1Code: this.customer.sa1Code,
					subPremise: this.customer.subPremise,
					streetNo: this.customer.streetNo,
					streetName: this.customer.streetName,
					streetAddress: this.customer.streetAddress,
					streetType: this.customer.streetType,
					suburb: this.customer.suburb,
					state: this.customer.state
				};
			}, 
			set(v: any): void {
				this.$store.commit('setCustomer', {
					postcode: v.postcode,
					address: v.address,
					unitNo: v.unitNo,
					streetNo: v.streetNo,
					sa1Code: v.sa1Code,
					subPremise: v.subPremise,
					streetName: v.streetName,
					streetAddress: v.streetAddress,
					streetType: v.streetType,
					suburb: v.suburb,
					state: v.state
				});
			}
		}, 
		customerPreferredDealership: {
			get(): string {
				return this.customer.preferredDealership;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					preferredDealership: v
				});
			}
		},
		customerDob: {
			get(): string {
				return this.customer.dob;
			}, 
			set(v): void {
				this.$store.commit('setCustomer', {
					dob: v
				});
			}
		}
	}, 
	methods: {
		handleFieldUpdate(fieldName: string, e: any): void {
			Helpers.clog(e);
			const suffix = Analytics.getSuffix();
			Analytics.sendEvent({
				"event": "formInteraction",
				"formName" : "Personal Details Form" + suffix,
				"fieldName" : fieldName,
				"fieldStatus" : "Edited"
			});
		}, 
		isABN(v: string){
			return Validation.validateABN(v);
		}
	}, 
	watch: {
		'personalBusinessTab'(v): void {
			const vReal = v + 1;
			this.$store.commit('setCustomer', {
				orderType: vReal
			});
			Api.getUpdatedfinance(this, function(){
				Analytics.sendEvent({
					"event": "changeGuestType",
					"guestType" : vReal == 1 ? 'Personal' : vReal == 2 ? 'Business' : 'Full Service Lease'
				});
			});
		}, 
		'isFormValid'(v, o){
			this.$emit('input', v);
		}
	}, 
	mounted(): void {
		if (this.customer.lastName){
			this.$nextTick(() => {
				this.$refs.detailForm.validate();
			});
		}
		this.dealershipOptions = this.dealer.dealerSites.map((d: any) => {
			return d.Suburb;
		}).sort();
		this.personalBusinessTab = this.customer.orderType - 1;
	}
});
